import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M11.807 10.758a4.875 4.875 0 1 0-1.048 1.048h-.001c.022.03.047.06.074.087l2.888 2.887a.75.75 0 1 0 1.06-1.06l-2.887-2.888a.763.763 0 0 0-.086-.074ZM12 7.875a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0Z"
    }, null, -1)
  ]))]))
}
export default { render: render }